import styled from 'styled-components';
import ContentSection from 'components/ContentSection';
import { colorBlack300, fontFamilyRoboto } from 'styleUtils';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-28irso-0"
})(["align-items:flex-start;display:flex;width:100%;"]);
export var Blocks = /*#__PURE__*/styled(ContentSection).withConfig({
  componentId: "sc-28irso-1"
})(["font-family:", ";font-size:16px;line-height:28px;color:", ";"], fontFamilyRoboto, colorBlack300);
export var BlockTitle = /*#__PURE__*/styled.h3.withConfig({
  componentId: "sc-28irso-2"
})([""]);